"use client"

import { Divider } from "@/components/atoms"
import { SingleProductSeller } from "@/types/product"
import { format } from "date-fns"
import { SellerAvatar } from "../SellerAvatar/SellerAvatar"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { useTranslate } from "@tolgee/react"

export const CartItemsHeader = ({
  seller,
}: {
  seller: SingleProductSeller
}) => {
  const { t } = useTranslate()
  return (
    <LocalizedClientLink href={`/sellers/${seller.handle}`}>
      <div className="border-t border-x rounded-t-[12px]">
        <div className="pt-[11.25px] pb-[13.25px] px-[18.75px] flex gap-[11.25px] items-center">
          <div className="shrink-0 size-[26px] overflow-hidden rounded-[3.75px] border border-[#e5e5e5]">
            <SellerAvatar photo={seller.photo} size={26} alt={seller.name} />
          </div>

          <p className="uppercase text-[14px] text-[#1a1a1a] font-medium tracking-[0.3px]">{seller.name}</p>
          {seller.id !== "fleek" && (
            <p className="text-[14px] text-[#8c8c8c]">
              • {t("seller.joined")} {format(seller.created_at || "", "yyyy-MM-dd")}
            </p>
          )}
        </div>
        <div className="border-b border-[#e5e5e5]" />
      </div>
    </LocalizedClientLink>
  )
}
